export const parseCookie = (str: string) => {
  if (!str) return {};
  return str
    .split(";")
    .map((v) => v.split("="))
    .reduce<{ [index: string]: string }>((acc, v) => {
      acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
      return acc;
    }, {});
};
